import { TransitionProposalsImportTypeKey } from "@fartherfinance/frontend/api/TransitionProposals/types";

import { ProgressPointState } from "@src/sharedComponents/FlowContainer/reducer/types";
import { Column } from "@src/sharedComponents/Table/Types";

import {
  CreateProposalButtonAction,
  TransitionProposalFlowPageIndex,
  TransitionProposalFlowStateData,
  TransitionProposalsTableColumnValue,
} from "./types";

export const importTypes: Record<string, TransitionProposalsImportTypeKey> = {
  STATEMENT: "statement",
  EXISTING: "existing",
  MANUAL: "manual",
};

type ClientColumn = Exclude<
  TransitionProposalsTableColumnValue,
  "status" | "action"
>;

export const clientColumns: Column<ClientColumn>[] = [
  { accessor: "name", label: "Proposals", sortable: false },
  { accessor: "updatedAt", label: "Updated", sortable: false },
];

export const advisorColumns: Column<TransitionProposalsTableColumnValue>[] = [
  { accessor: "name", label: "Proposals", sortable: false },
  { accessor: "status", label: "Status", sortable: false },
  { accessor: "updatedAt", label: "Updated", sortable: false },
  { accessor: "action", label: "Action", sortable: false },
];

export const proposalCardButtons: CreateProposalButtonAction[] = [
  {
    title: "Start with a statement",
    description:
      "Import holdings from account statements or other documents. You can always add or adjust data manually later.",
    type: "statement",
  },
  {
    title: "Start with an existing Farther Account",
    description:
      "Start with holdings from existing Farther-managed account(s).",
    type: "existing",
  },
  {
    title: "Manually enter data",
    description:
      "Enter current holdings manually. Choose this option only if you don't have a document or Farther-managed account to start from.",
    type: "manual",
  },
];
interface InitialState {
  pageIndex: TransitionProposalFlowPageIndex;
  progressState: {
    name: string;
    state: ProgressPointState;
  }[];
  data: TransitionProposalFlowStateData;
}

export const initialTransitionProposalFlowState: InitialState = {
  pageIndex: TransitionProposalFlowPageIndex.Add,
  progressState: [
    { name: "Start", state: ProgressPointState.Complete },
    { name: "Add Data", state: ProgressPointState.InProgress },
    { name: "Review Data", state: ProgressPointState.NotStarted },
    { name: "Modify & Share", state: ProgressPointState.NotStarted },
  ],
  data: {
    importType: importTypes.MANUAL,
    resources: [],
    documentPreviewFilterClicked: false,
    holdingsFilters: {
      type: [],
      name: [],
      costBasis: [null, null],
      marketValue: [null, null],
      quantity: [null, null],
      fileName: [],
      price: [null, null],
      ticker: [],
      accountName: [],
      unrealizedGainOrLoss: [null, null],
      percentOfAccount: [null, null],
      statementPeriod: [],
    },
    appliedFilter: undefined,
    filterSearchTerm: "",
    showCustomPortfolioModal: false,
    hasTransitionProposalDetailsError: false,
  },
};
